<template>
  <div>
    <md-toolbar
      class="md-primary"
      style="background-color: rgb(44, 105, 188)!important"
      md-elevation="5">
      <router-link to="/accountant/requests"><img
        src="/static/logo.png"
        alt="ClippFácil"
        style="max-height: 30px; margin: 8px 45px;"></router-link>

      <router-link to="/accountant/requests"><md-button>Empresas Vinculadas</md-button></router-link>

      <div class="md-toolbar-section-end">
        <md-chip
          v-if="$store.getters.nameClient"
          md-disabled
          style="color: #fff;">{{ $store.getters.client.name }} - {{ $store.getters.nameClient }}
        </md-chip>
        <md-chip
          v-else
          md-disabled
          style="color: #fff;">{{ $store.getters.client.name }} - Nenhum cliente selecionado
        </md-chip>

        <md-menu
          md-size="big"
          md-direction="bottom-end">
          <md-button
            class="md-icon-button"
            md-menu-trigger>
            <md-icon>contacts</md-icon>
            <md-tooltip md-direction="bottom">Selecionar cliente</md-tooltip>
          </md-button>

          <md-menu-content v-if="clientsActivated">
            <div v-for="(item) in clientsActivated">
              <md-menu-item
                v-if="item.accessAllowed === true"
                @click="clientSelected(item)">
                <md-tooltip
                  v-if="$store.getters.idClient == item.client.id"
                  md-direction="left">Cliente Selecionado</md-tooltip>
                <md-tooltip
                  v-else
                  md-direction="left">Selecionar Cliente</md-tooltip>
                <div class="menu-client">
                  <md-icon>account_circle</md-icon>
                  <label
                    v-if="$store.getters.idClient == item.client.id"
                    class="title-card-menu-name-selected">{{ item.client.name }}</label>
                  <label
                    v-else
                    class="title-card-menu-name">{{ item.client.name }}</label>
                  <p
                    v-if="item.client.identification.length == 14"
                    class="title-card-menu-identification">{{ item.client.identification | mask('##.###.###/####-##') }}</p>
                  <p
                    v-else
                    class="title-card-menu-identification">{{ item.client.identification | mask('###.###.###-##') }}</p>
                </div>
                <md-divider class="md-inset"/>
              </md-menu-item>
            </div>
          </md-menu-content>
        </md-menu>

        <md-menu
          md-size="big"
          md-direction="bottom-end">
          <md-button
            class="md-icon-button"
            md-menu-trigger>
            <md-icon>menu</md-icon>
          </md-button>
          <md-menu-content>
            <md-menu-item @click="config">
              <span>Configurações</span>
              <md-icon>settings</md-icon>
            </md-menu-item>
            <md-menu-item @click="logout">
              <span>Sair</span>
              <md-icon>exit_to_app</md-icon>
            </md-menu-item>
          </md-menu-content>
        </md-menu>

      </div>
    </md-toolbar>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { http } from '../../public/api/backend';
import { store } from '../../public/api/store';

export default {
  name: 'Menu',
  data() {
    return {
      client: {},
      clientsActivated: [],
    };
  },

  computed: {
    identificationClient() {
      return this.$store.getters.identificationClient
    },
  },
  created() {
    this.getAccountantRequest()
    this.fetchClient()
  },

  methods: {

    ...mapActions([
      'fetchClient',
      'getDocuments',
    ]),

    getAccountantRequest() {
      http.post('clipp.get-accountant-access-request')
        .then(response => {
          this.clientsActivated = response.data.requests
        })
    },

    logout() {
      http.post('application.logout')
        .then(response => {
          localStorage.removeItem('vuex')
          localStorage.removeItem('access_token')
          this.$router.push({ path: '/' })
          this.$toasted.show('Deslogado com sucesso.', {
            theme: 'outline',
            position: 'bottom-right',
            duration: 2000,
            type: 'success',
            icon: 'check_circle'
          });
        })
    },


    clientSelected(item) {
      if (!item) {
        return
      }
      this.$store.commit('SET_CLIENT_ID', item.client.id)
      this.$store.commit('SET_CLIENT_NAME', item.client.name)
      this.$store.commit('SET_CLIENT_IDENTIFICATION', item.client.identification)
      this.$store.commit('SET_PAGE', 1)
      this.$store.dispatch('cleanLinkDownload')
      this.$store.dispatch('getDocuments')
      this.$toasted.show('Os dados foram atualizados.', {
        theme: 'outline',
        position: 'bottom-left',
        duration: 2000,
        type: 'success',
        icon: 'check_circle'
      });
      setTimeout(() => {
        this.$router.push({ path: '/accountant/documents' })
      }, 3050)
    },

    config() {
      setTimeout(() => {
        this.$router.push({ path: '/accountant/perfil' })
      }, 250)
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/accountant/public/Menu.vue